module.exports = __webpack_public_path__ + "static/media/messenger.3aacd92b.svg";